import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
// import { AnnouncementBarComponent } from "./components/announcement-bar/announcement-bar.component";
import { HeaderComponent } from './components/header/header.component';
import { ShopifyStorefrontService } from './services/shopify-storefront.service';
import { getCollectionProductsByHandle } from './services/product-queries/get-collection-products';
import { FooterComponent } from './components/footer/footer.component';
// import { cachedProducts } from './services/starter-products';x`

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    // AnnouncementBarComponent,
    HeaderComponent,
    FooterComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, AfterViewInit {
  dataToCache: any[] = [];
  constructor(private data: ShopifyStorefrontService, private router: Router) {}

  ngOnInit() {
    this.fetchCachedProducts();

    if (typeof window !== 'undefined') {
      this.router.events.subscribe(() => {
        if (
          this.router.url.includes('/product/') ||
          this.router.url.includes('/contact')
        ) {
          window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }
      });
    }
  }

  ngAfterViewInit() {
    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      requestIdleCallback(() => this.rehydrateProductsFromStorefrontAPI());
    } else {
      // fallback for Safari or SSR-safe environments
      setTimeout(() => this.rehydrateProductsFromStorefrontAPI(), 1);
    }
  }

  // async loadCachedProducts() {
  //   this.data.allProducts.set(cachedProducts);
  // }
  async fetchCachedProducts() {
    // const date = new Date();
    // const year = date.getFullYear();
    // const month = String(date.getMonth() + 1).padStart(2, '0');
    // const day = String(date.getDate()).padStart(2, '0');
    // const formattedDate = `${year}-${month}-${day}`;
    // const cacheStr = formattedDate;
    // const gzippedCachedDataURI = `https://cdn.assests.bornprimitive.com/cache/all-taa-berry.min.json?${cacheStr}`;
    const gzippedCachedDataURI = `https://cdn.assests.bornprimitive.com/cache/all-taa-berry.json`;
    const response = await fetch(gzippedCachedDataURI);
    if (response.ok) {
      const data: any = await response.json();
      this.data.allProducts.set(data);
    } else {
      console.error('Failed to fetch cached products:', response.statusText);
    }
    // fetch(gzippedCachedDataURI).then(async (response) => {
    //   if (response.ok) {
    //     const data: any = await response.json();
    //     this.data.allProducts.set(data);
    //   }
    // });
  }

  fetchProductsFromStoreFrontAPIForCache(
    handle: string = 'taa-berry-all',
    first: number = 99,
    after: any = null
  ) {
    this.data
      .genericQuery(getCollectionProductsByHandle, { handle, first, after })
      .subscribe((data: any) => {
        const hasNextPage = data.data.collection.products.pageInfo.hasNextPage;
        const endCursor = data.data.collection.products.pageInfo.endCursor;
        if (hasNextPage) {
          this.fetchProductsFromStoreFrontAPIForCache(handle, first, endCursor);
        }
        const existingProductsForCache = this.dataToCache || [];
        const newProducts = data.data.collection.products.edges.map(
          (edge: any) => edge.node
        );
        this.dataToCache = [...existingProductsForCache, ...newProducts];
        if (!hasNextPage) {
          this.refreshCache();
        }
      });
  }

  rehydrateProductsFromStorefrontAPI(
    handle: string = 'taa-berry-all',
    first: number = 99,
    after: any = null
  ) {
    this.data
      .genericQuery(getCollectionProductsByHandle, { handle, first, after })
      .subscribe((data: any) => {
        const edges = data.data.collection.products.edges;
        const newProducts = edges.map((edge: any) => edge.node);
        // Merge by ID
        const existing = this.data.allProducts() || [];
        const merged = this.mergeProducts(existing, newProducts);

        this.data.allProducts.set(merged);

        const pageInfo = data.data.collection.products.pageInfo;
        if (pageInfo.hasNextPage) {
          this.rehydrateProductsFromStorefrontAPI(
            handle,
            first,
            pageInfo.endCursor
          );
        }
      });
  }

  mergeProducts(existing: any[], incoming: any[]): any[] {
    const map = new Map();

    // Add existing
    for (const product of existing) {
      map.set(product.id, product);
    }

    // Add/update with incoming
    for (const product of incoming) {
      map.set(product.id, product);
    }

    return Array.from(map.values());
  }

  async refreshCache() {
    this.data.allProducts.set(this.dataToCache);
    console.log('Refreshing cache with:', this.dataToCache);
    const api = '/api/refresh-cache';
    const payload = {
      data: this.dataToCache,
      key: 'cache/all-taa-berry.json',
    };
    const headers = {
      'Content-Type': 'application/json',
    };
    const options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
    };
    const response = await fetch(api, options);
    if (response.ok) {
      const data = await response.json();
      console.log('Cache refreshed:', data);
    }
  }
}
